import { render, staticRenderFns } from "./category_print.vue?vue&type=template&id=a8c80950&scoped=true&"
import script from "./category_print.vue?vue&type=script&lang=js&"
export * from "./category_print.vue?vue&type=script&lang=js&"
import style0 from "./category_print.vue?vue&type=style&index=0&id=a8c80950&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8c80950",
  null
  
)

export default component.exports